/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Trick-play mode determined at runtime by capability detection.
 * Selection precedence: Thumbnail > IFrame > Emulated.
 */
export enum TrickPlayMode {
  /** Small preview overlay rendered by UI using ThumbnailManager. */
  Thumbnail = "thumbnail",

  /** Full-screen i-frame via IPlayer.setTrickPlayRate(rate, true). */
  IFrame = "iframe",

  /** No visual preview; position-only seeking via repeated seek(). */
  Emulated = "emulated"
}
